import { Injectable } from '@angular/core';
import { User } from '../../constants/user-info';
import { UserConfigService } from '../user-config/user-config.service';
import { PageInfo, AnalyticsDataLayer } from 'src/app/common/interface/adobe-analytics.interface';
import { DELOITTE_USER_DOMAIN, EXTERNAL_USER } from 'src/app/common/constants/app.constants';

@Injectable({providedIn: 'root'})
export class AdobeAnalyticsService {
  userData: User;
  eventTracker: {
    analyticsDataLayer: AnalyticsDataLayer;
    _satellite: {
      track: (event: string) => {};
    };
  };

  constructor(private userConfig: UserConfigService) {
    this.eventTracker = window as any;
  }

  /**
   * Retrives the pageinfo object from analytics layer 
   * @returns {PageInfo | undefined} returns pageInfo object from analytics data layer if exists else undefined
   */
  private get pageInfo(): PageInfo {
    return this.eventTracker?.analyticsDataLayer && this.eventTracker?.analyticsDataLayer.pageInfo;
  }

  /** 
   * setUserId: method will be used to set the userID from userConfig
   */
  setUserId = () => {
    if (this.pageInfo) {
      this.userConfig.getUserInfo().subscribe((data) => {
        const [user, domain] = data.userId.split("@");
        this.pageInfo.userID = domain === DELOITTE_USER_DOMAIN ? user : EXTERNAL_USER;
      });
    }
  };

  /**
   * setPageName: method will be used to set page url 
   * 
   * @param {string} pageName
   */
  setPageName = (pageName: string) => {
    if (this.pageInfo) {
      this.pageInfo.pageName = pageName;
    }
  }

  /**
   * setApplicationName: method will be used to set Application Name
   * 
   * @param {string} applicationName
   */
  setApplicationName = (applicationName: string) => {
    if (this.pageInfo) {
      this.pageInfo.applicationName = applicationName;
    }
  }

  /**
   * SetActonName: method will be used to set name of the button clicked
   * 
   * @param {string} action name of the button, image or icon
   */
  setActonName = (action: string) => {
    if (this.pageInfo) this.pageInfo.actions = action;
  }

  /**
   * SetLinkName: method will be used to set the external url clicked
   * 
   * @param {string} url
   */
  setLinkName = (url: string) => {
    if (this.pageInfo) this.pageInfo.links = url;
  }

  /**
   * TrackActionEvent: method will be used to track the event change
   * 
   * @param {string} logType
   */
  trackActionEvent = (logType: string) => {
    if (this.eventTracker && this.eventTracker?._satellite && this.eventTracker?._satellite.track) 
      this.eventTracker._satellite.track(logType);
  }
}